import { createIcon } from '@chakra-ui/react';

export const MbeUpload = createIcon({
  displayName: 'MbeUpload',
  viewBox: '0 0 64 64',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.58 27.52 33.243 16.307a1.633 1.633 0 0 0-1.244-.46 1.63 1.63 0 0 0-1.244.46L19.422 27.52a1.61 1.61 0 0 0 0 2.298c.641.635 1.683.635 2.323 0l8.612-8.52v35.077c0 .897.736 1.625 1.643 1.625s1.643-.728 1.643-1.625V21.298l8.613 8.52c.641.635 1.683.635 2.323 0 .641-.636.641-1.664 0-2.298zM15.571 51.5H20.5v-3.25h-4.928c-1.814 0-3.286-1.454-3.286-3.25V12.5c0-1.796 1.472-3.25 3.286-3.25h32.857c1.815 0 3.285 1.454 3.285 3.25V45c0 1.796-1.47 3.25-3.285 3.25H43.5v3.25h4.929C52.058 51.5 55 48.59 55 45V12.5C55 8.91 52.058 6 48.429 6H15.57C11.942 6 9 8.91 9 12.5V45c0 3.59 2.942 6.5 6.572 6.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});
